import React from 'react';
import T from 'prop-types';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

const confirm = (onOk) => {
  Modal.confirm({
    title: 'Confirm New API Key Generation',
    content: 'Generating a new API key will disable your current key. Do you want to continue?',
    okText: 'Yes, generate new key',
    okButtonProps: { type: 'danger' },
    cancelText: 'Cancel',
    onOk: (close) => {
      onOk();
      close();
    },
    icon: <ExclamationCircleOutlined />,
  });
};

const GenerateKeyButton = ({ onClick, needsConfirmation }) => {
  if (!needsConfirmation) {
    return (
      <Button onClick={onClick} type="primary">
        Generate Key
      </Button>
    );
  }

  return (
    <Button onClick={() => confirm(onClick)} type="primary">
      Generate
    </Button>
  );
};

GenerateKeyButton.propTypes = {
  onClick: T.func.isRequired,
  needsConfirmation: T.bool.isRequired,
};

export default GenerateKeyButton;
